import { render, staticRenderFns } from "./WorkflowDetailService.vue?vue&type=template&id=3322aa1f&scoped=true"
import script from "./WorkflowDetailService.vue?vue&type=script&lang=js"
export * from "./WorkflowDetailService.vue?vue&type=script&lang=js"
import style0 from "./WorkflowDetailService.vue?vue&type=style&index=0&id=3322aa1f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3322aa1f",
  null
  
)

export default component.exports